import {
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  SimpleChanges,
  inject,
} from '@angular/core';
import { SafeCheckPipe } from '@boels/helpers';
import { BackgroundColorEnum, BoelsTeaserComponentData } from '@boels/models';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { GenericLinkWrapperComponent } from '../../../../generic-link-wrapper/generic-link-wrapper.component';
import { faArrowRight } from '@fortawesome/free-solid-svg-icons';

import { MediaService } from '@boels/services';

@Component({
  imports: [FontAwesomeModule, GenericLinkWrapperComponent, SafeCheckPipe],
  selector: 'boels-teaser-rectangle',
  templateUrl: './teaser-rectangle.component.html',
  styleUrls: ['./teaser-rectangle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TeaserRectangleComponent implements OnChanges {
  mediaService = inject(MediaService);

  arrowRightIcon = faArrowRight;
  backgroundColor = BackgroundColorEnum;
  mediaUrl: string;
  @Input() teaserComponentData: BoelsTeaserComponentData;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.['teaserComponentData']) {
      this.mediaUrl = this.getMediaUrl();
    }
  }

  getMediaUrl(): string {
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return this.mediaService.getMedia(this.teaserComponentData?.image)?.src;
  }
}
